export default {
  admin: () => import("/opt/buildhome/repo/layouts/Admin.vue").then(m => m.default || m),
  "app-configurator": () => import("/opt/buildhome/repo/layouts/AppConfigurator.vue").then(m => m.default || m),
  "app-footer": () => import("/opt/buildhome/repo/layouts/AppFooter.vue").then(m => m.default || m),
  "app-menu": () => import("/opt/buildhome/repo/layouts/AppMenu.vue").then(m => m.default || m),
  "app-menu-item": () => import("/opt/buildhome/repo/layouts/AppMenuItem.vue").then(m => m.default || m),
  "app-sidebar": () => import("/opt/buildhome/repo/layouts/AppSidebar.vue").then(m => m.default || m),
  "app-topbar": () => import("/opt/buildhome/repo/layouts/AppTopbar.vue").then(m => m.default || m),
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)
}